import type { MutationTree, Store } from "vuex";
import type { State } from "@/store/state";
import type { DeviceState } from "./state";
import type { Device } from "@/interfaces/devices";

export const mutations: MutationTree<DeviceState> = {
  setDevices(state, devices: Device[]): void {
    state.devices = devices;
  },
};

const NS = "devices/";

export const commitSetDevices = (
  store: Store<State>,
  payload: Device[],
): void => {
  store.commit(`${NS}setDevices`, payload);
};
